const getTimezoneAbbreviation = (date = new Date()) => {
    const timeString = date.toLocaleTimeString('en-US', {
        timeZoneName: 'short',
    });
    const abbreviation = timeString.split(' ').pop();
    return abbreviation;
};

export const formatDateWithTimeZone = (dateInput?: {
    day: string;
    hours: number;
    minutes: number;
}) => {
    // Return em dash if input is undefined
    if (!dateInput) {
        return '—';
    }

    try {
        const now = new Date();
        const targetDate = new Date(now);
        const dayNames = [
            'sunday',
            'monday',
            'tuesday',
            'wednesday',
            'thursday',
            'friday',
            'saturday',
        ];
        const targetDayIndex = dayNames.findIndex(
            (d) => d.toLowerCase() === dateInput.day.toLowerCase(),
        );

        if (targetDayIndex !== -1) {
            const currentDayIndex = now.getDay();
            let daysToAdd = targetDayIndex - currentDayIndex;

            if (daysToAdd < 0) {
                daysToAdd += 7;
            }

            targetDate.setDate(now.getDate() + daysToAdd);
        }

        targetDate.setHours(dateInput.hours || 0);
        targetDate.setMinutes(dateInput.minutes || 0);

        const tzAbbreviation = getTimezoneAbbreviation(targetDate);

        return `${dateInput.day}, ${formatTime(
            dateInput.hours,
            dateInput.minutes,
        )} ${tzAbbreviation}`;
    } catch (error) {
        console.error('Error formatting date:', error);
        return '—';
    }
};

function formatTime(hours: number, minutes: number): string {
    const period = hours >= 12 ? 'PM' : 'AM';
    const displayHours = hours % 12 || 12;
    const displayMinutes = minutes < 10 ? `0${minutes}` : minutes;

    return `${displayHours}:${displayMinutes}${period}`;
}
